/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Box from '@material-ui/core/Box';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  TableHeaderForInvoiceNumber,
  TableHeaderForQuarter,
} from './gridComponent/tableHead';
import {
  getInvoiceGridList,
  getInvoiceQuarterData,
  getExistingCorrLinkIds,
  setViewCheckAllocationTab,
} from '../store/actions';
import { tableGridHight350 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  redirectURLLink,
  handleScrollToEvent,
  removeDollarForNumberFiled,
  removeCommaForNumberFiled,
  closeTab,
  redirectNewCombination,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  dispatchActiveInvoiceNumber,
  getRosiAllocatePaymentDetail,
  handleErrorMessageForAllocatePayment,
  setPerviousScreenReduxData,
  clearReduxAllocatePaymentThirdScreen,
  dispatchAllocatePaymentHederData,
} from '../../AllocatePayments/store/Actions';
import { getAllocatePaymentScreenData } from '../../AllocatePayments/components/gridComponents/ROSIUtils';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';
import { dispatchSaveDetailsResponse } from '../../AllocatePayments/PQASTab/store/Actions';

function ViewCheckAllocation() {
  const RedColor = '#a81f00';
  const dispatch = useDispatch();
  const history = useHistory();
  const getInvoiceData = useSelector(
    (state) => state.sharedState.ViewCheckAllocation?.InvoiceList
  );
  const getInvoiceDataQuarterData = useSelector(
    (state) => state.sharedState.ViewCheckAllocation?.invoiceGridQuarter
  );
  const viewCheckAllocationDetail = useSelector(
    (state) => state.sharedState.ViewCheckAllocation?.viewCheckAllocationDetails
  );
  const viewCheckAllocationTab = useSelector(
    (state) => state.sharedState.ViewCheckAllocation?.viewCheckAllocationObj
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const searchScreenTabData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  // variable deceleration
  const [fullScreenView, setFullScreenView] = React.useState(
    viewCheckAllocationTab.fullScreenView || false
  );
  const [fullScreenView1, setFullScreenView1] = React.useState(
    viewCheckAllocationTab.fullScreenView1 || false
  );
  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const [modalTitle, setModalTitle] = React.useState('');
  const [showComments, setShowComments] = React.useState(false);
  const [callCommentAPI, setCallCommentAPI] = React.useState(true);
  const [commentShow, setCommentShow] = React.useState(false);
  const [quarterGridList, setQuarterGridList] = React.useState([]);
  const [index, setIndex] = React.useState(viewCheckAllocationTab.index || 0);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [alreadyExistInvoiceNum, setAlreadyExistInvoiceNum] =
    React.useState(false);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
    }
  }, []);

  const updateDetailsAllData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.updateDetails
  );
  // click on full screen icon after call
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setViewCheckAllocationTab({
        fullScreenView: !fullScreenView,
        fullScreenView1: false,
      })
    );
  };
  // handing full screen view function
  const handleFullScreenView1 = () => {
    setFullScreenView1(!fullScreenView1);
    dispatch(
      setViewCheckAllocationTab({
        fullScreenView1: !fullScreenView1,
        fullScreenView: false,
      })
    );
  };

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    if (data) {
      setCallCommentAPI(false);
      const result = await getExistingCorrLinkIds({
        corrLinkId: [data.corrLinkId],
      });
      if (result && result.data?.length > 0) {
        result.data.forEach((elem) => {
          if (elem === data.corrLinkId) {
            setCommentShow(true);
          }
        });
      } else {
        setCommentShow(false);
      }
    }
  };
  React.useEffect(() => {
    if (showComments) {
      handleExistingCommentList(viewCheckAllocationDetail);
    }
  }, [commentsList]);
  React.useEffect(() => {
    if (getInvoiceData?.length > 0) {
      const selectRow = getInvoiceData[index || 0];
      dispatch(
        getInvoiceQuarterData({
          checkLogNumber: viewCheckAllocationDetail.checkLogNum,
          invoiceNum: selectRow.invoiceNum,
        })
      );
    }
  }, [getInvoiceData]);
  React.useEffect(() => {
    handleScrollToEvent();
    const obj = {
      checkLogNumber: viewCheckAllocationDetail?.checkLogNum,
    };
    if (viewCheckAllocationDetail) {
      removeDollarForNumberFiled(
        removeCommaForNumberFiled(viewCheckAllocationDetail?.checkAmt)
      );
      removeDollarForNumberFiled(
        removeCommaForNumberFiled(viewCheckAllocationDetail?.totAllocatedAmt)
      );
    }
    if (callCommentAPI) {
      handleExistingCommentList(viewCheckAllocationDetail);
    }
    dispatch(getInvoiceGridList(obj));
  }, [viewCheckAllocationDetail]);

  React.useEffect(() => {
    let tempObj = [];
    if (getInvoiceDataQuarterData?.length > 0) {
      tempObj = getInvoiceDataQuarterData?.map((item) => {
        if (!item.intrestPaidAmt?.toString()?.includes('$'))
          item.intrestPaidAmt = `$ ${
            item.intrestPaidAmt !== null
              ? item.intrestPaidAmt.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                })
              : '0.00'
          }`;
        if (!item.principalPaidAmt?.toString()?.includes('$'))
          item.principalPaidAmt = `$ ${
            item.principalPaidAmt !== null
              ? item.principalPaidAmt.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                })
              : '0.00'
          }`;
        item.negativeValIntrestPaidAmt = !(
          parseFloat(item.intrestPaidAmt?.toString().split('$')[1]) >= 0
        );
        item.negativeValPrincipalPaidAmt = !(
          parseFloat(item.principalPaidAmt?.toString().split('$')[1]) >= 0
        );
        item.invoiceNum = getInvoiceData[index].invoiceNum;
        item.mfgId = getInvoiceData[index].mfgId;
        item.rebateProgramCd = getInvoiceData[index].rebateProgramCd;
        item.qtr = item.invRecQtr;
        return item;
      });
    }
    setQuarterGridList(tempObj);
  }, [getInvoiceDataQuarterData]);
  // handing by default 1st row selection function
  const onGridReady = (params) => {
    if (params?.api) {
      params.api.forEachNode(
        (node) => node?.rowIndex === index && node?.setSelected(true)
      );
    }
  };
  //  row selection function
  const onRowSelect = (row) => {
    if (
      quarterGridList?.length === 0 ||
      quarterGridList?.filter((x) => {
        return x.invoiceNum !== row?.invoiceNum;
      }).length > 0
    ) {
      if (row?.invoiceNum) {
        dispatch(
          getInvoiceQuarterData({
            checkLogNumber: viewCheckAllocationDetail.checkLogNum,
            invoiceNum: row.invoiceNum,
          })
        );
      }
    }
  };

  // click on redirect maintain Check screen
  const handleMaintainCheck = () => {
    window.localStorage.setItem(
      'checkSearchValues',
      JSON.stringify(viewCheckAllocationDetail)
    );
    redirectURLLink('/maintain-check', 'Maintain Check', history, dispatch);
  };

  // handing Invoice Detail page redirect
  const handleViewDetailsForInvoiceDetail = async (row) => {
    await dispatch(
      getInvoiceDetailsByInvoiceNum({
        invoiceNum: row.invoiceNum,
      })
    );
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );

  const activeScreenDetails = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.activeDetailScreenTabs
  );
  // redirectionFunction
  // const redirectNewCombination = async (newTarget) => {
  //   if (!newTarget) return;
  //   const newObj = [];
  //   newObj.push({
  //     index: newObj.length,
  //     invoiceNum: newTarget.invoiceNumber,
  //     checkLogNum: newTarget.checkNumber,
  //     active: true,
  //   });
  //   const resultData = await dispatch(
  //     getRosiAllocatePaymentDetail({
  //       invoiceNum: newTarget.invoiceNumber,
  //       checkLogNum: newTarget.checkNumber,
  //       checkPayeeCD: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
  //       checkAmt:
  //         parseFloat(
  //           viewCheckAllocationDetail?.checkAmt?.toString().replace('$ ', '')
  //         ) || 0,
  //       mfgId: newTarget.mfgId,
  //       planType: newTarget.planType,
  //     })
  //   );
  //   dispatch(
  //     setPerviousScreenReduxData({
  //       ...searchScreenTabData,
  //       state: {
  //         ...searchScreenTabData.state,
  //         allocateFrom: 'Check',
  //       },
  //       selectedRow: {
  //         ...viewCheckAllocationDetail,
  //         checkPayeeCdVal: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
  //       },
  //     })
  //   );
  //   const data = resultData?.headerAllocatePaymentData;
  //   const headerAllocatePaymentVO =
  //     resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
  //   if (
  //     headerAllocatePaymentVO &&
  //     Object.keys(headerAllocatePaymentVO).length
  //   ) {
  //     dispatch(dispatchActiveInvoiceNumber(newObj));
  //     const obj = { ...AllocatePaymentReducer?.detailScreenErrors };
  //     obj[
  //       `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
  //     ] = [];
  //     dispatch(
  //       handleErrorMessageForAllocatePayment({
  //         detailScreenErrors: obj,
  //         searchScreenErrors: AllocatePaymentReducer?.searchScreenErrors
  //           ? AllocatePaymentReducer?.searchScreenErrors
  //           : [],
  //       })
  //     );
  //     dispatch(dispatchSaveDetailsResponse({}));
  //     getAllocatePaymentScreenData(
  //       data,
  //       dispatch,
  //       AllocatePaymentReducer,
  //       history,
  //       newObj
  //     );
  //   } else if (data?.forzenCase) {
  //     setWarningAlert(true);
  //     setModalTitle('Warning');
  //     setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
  //   } else if (data?.noCheckPayeeForInvoice) {
  //     setWarningAlert(true);
  //     setModalTitle('Warning');
  //     setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
  //   } else if (
  //     data?.headerAllocatePaymentVO == null &&
  //     data?.checkPayeeMessage
  //   ) {
  //     setWarningAlert(true);
  //     setWaringMessage(data?.checkPayeeMessage);
  //     setModalTitle('Warning');
  //   }
  // };
  // modal handler
  // const handleReplaceModalOk = async () => {
  //   setAlreadyExistInvoiceNum(false);

  //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
  //   const existingTab = window.existingTabToClose;

  //   if (!existingTab) return; // Prepare destination info

  //   const newCheck = viewCheckAllocationDetail.checkLogNum;
  //   const newInvoice = existingTab.invoiceNumber;
  //   const destinationPath = `/allocatePaymentDetail/${newCheck}-${newInvoice}`;
  //   const destinationTitle = `ROSI/PQAS [#${newInvoice}] Check Log #${newCheck}`;

  //   const hasUnsavedChanges =
  //     existingTab &&
  //     hasUnsavedChangesFor(
  //       existingTab.invoiceNumber,
  //       existingTab.checkNumber,
  //       updateTabs.find((tab) => tab.navTo === existingTab.navTo)
  //     );
  //   console.log('hasUnsavedChanges', hasUnsavedChanges);
  //   if (existingTab && hasUnsavedChanges) {
  //     // Mark tab for save and navigation
  //     updateTabs.forEach((tab) => {
  //       if (tab.navTo === existingTab.navTo) {
  //         tab.isSave = true;
  //         tab.showConfirmClose = true;
  //         tab.isClosing = true;
  //         tab.isDirty = true;
  //         tab.redirectURLObj = {
  //           checkLogNum: newCheck,
  //           invoiceNum: newInvoice,
  //           perviousNavTo: true,
  //           destinationAfterSave: {
  //             path: destinationPath,
  //             title: destinationTitle,
  //             target: {
  //               invoiceNumber: newInvoice,
  //               checkNumber: newCheck,
  //               mfgId: existingTab.mfgId || getInvoiceData[index].mfgId,
  //               planType:
  //                 existingTab.planType || getInvoiceData[index].rebateProgramCd,
  //             },
  //           },
  //         };
  //         tab.nextRoute = destinationPath;
  //         tab.nextTabTitle = destinationTitle;
  //       }
  //     });
  //     localStorage.setItem('tabItemsData', JSON.stringify(updateTabs)); // Navigate to trigger save dialog

  //     redirectURLLink(existingTab.navTo, existingTab.tabId, history);
  //   } 
  //   else {
  //     // Handle no unsaved changes case
  //     updateTabs.forEach((t) => (t.isAlreadyExistInvoiceNum = false));
  //     localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

  //     if (existingTab) {
  //       // Close existing tab
  //       closeTab(existingTab.navTo, history); // Clear redux state

  //       dispatch(
  //         clearReduxAllocatePaymentThirdScreen(
  //           existingTab.invoiceNumber,
  //           existingTab.checkNumber,
  //           history
  //         )
  //       ); // Clear header data

  //       if (
  //         AllocatePaymentReducer?.headerAllocatePaymentData?.[
  //           `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
  //         ]
  //       ) {
  //         dispatch(
  //           dispatchAllocatePaymentHederData(
  //             {
  //               ...AllocatePaymentReducer.headerAllocatePaymentData[
  //                 `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
  //               ],
  //               closeTab: true,
  //             },
  //             existingTab.invoiceNumber,
  //             existingTab.checkNumber
  //           )
  //         );
  //       }

  //       window.existingTabToClose = null; // Create new target object with the current check number and existing invoice

  //       const newTarget = {
  //         invoiceNumber: existingTab.invoiceNumber,
  //         checkNumber: viewCheckAllocationDetail.checkLogNum,
  //         mfgId: existingTab.mfgId || getInvoiceData[index].mfgId,
  //         planType:
  //           existingTab.planType || getInvoiceData[index].rebateProgramCd,
  //       }; // Open new combination

  //       // redirectNewCombination(newTarget);
  //     }
  //   }
  // };
  const handleReplaceModalOk = async () => {
    setAlreadyExistInvoiceNum(false);

    const updateTabs = JSON.parse(localStorage.getItem("tabItemsData")) || [];
    const existingTab = window.existingTabToClose;

    if (!existingTab) return; // Prepare destination info

    const newInvoice = existingTab?.newTarget?.invoiceNumber;
    const newCheck = existingTab?.newTarget?.checkNumber;
    const destinationPath = `/allocatePaymentDetail/${newCheck}-${newInvoice}`;
    const destinationTitle = `ROSI/PQAS [#${newInvoice}] Check Log #${newCheck}`; // Check for unsaved changes

    const hasUnsavedChanges =
      existingTab &&
      hasUnsavedChangesFor(
        existingTab.invoiceNumber,
        existingTab.checkNumber,
        updateTabs.find((tab) => tab.navTo === existingTab.navTo)
      );

    if (existingTab && hasUnsavedChanges) {
      // Mark tab for save and navigation, but DO NOT set isClosing here!
      updateTabs.forEach((tab) => {
        if (tab.navTo === existingTab.navTo) {
          tab.isSave = true;
          tab.showConfirmClose = true;
          tab.isDirty = true;
          tab.redirectURLObj = {
            checkLogNum: newCheck,
            invoiceNum: newInvoice,
            perviousNavTo: true,
            destinationAfterSave: {
            path: destinationPath,
              title: destinationTitle,
              target: existingTab.newTarget,
            },
          };
          tab.nextRoute = destinationPath;
          tab.nextTabTitle = destinationTitle; // DO NOT set tab.isClosing here!
        }
      });
      localStorage.setItem("tabItemsData", JSON.stringify(updateTabs)); // Navigate to trigger save dialog in the detail screen

      redirectURLLink(existingTab.navTo, existingTab.tabId, history);
      return;
    } // Handle no unsaved changes case

    updateTabs.forEach((t) => (t.isAlreadyExistInvoiceNum = false));
    localStorage.setItem("tabItemsData", JSON.stringify(updateTabs));

    if (existingTab) {
      // Close existing tab
      closeTab(existingTab.navTo, history); // Clear redux state

      dispatch(
        clearReduxAllocatePaymentThirdScreen(
          existingTab.invoiceNumber,
          existingTab.checkNumber,
          history
        )
      ); // Clear header data

      if (
        AllocatePaymentReducer?.headerAllocatePaymentData?.[
          `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
        ]
      ) {
        dispatch(
          dispatchAllocatePaymentHederData(
            {
              ...AllocatePaymentReducer.headerAllocatePaymentData[
                `${existingTab.invoiceNumber}-${existingTab.checkNumber}`
              ],
              closeTab: true,
            },
            existingTab.invoiceNumber,
            existingTab.checkNumber
          )
        );
      }

      window.existingTabToClose = null; // Open new combination using the reusable function

      await redirectNewCombination(
        existingTab.newTarget,
        history,
        dispatch,
        viewCheckAllocationDetail,
        searchScreenTabData,
        AllocatePaymentReducer
      );
    }
  };
  // NEW: Helper to determine unsaved changes for a given invoice-check combo (graceful fallback)
  const hasUnsavedChangesFor = React.useCallback(
    (invoiceNum, checkNum, detailObj) => {
      if (!invoiceNum || !checkNum) return false;
      const detailKey = `${invoiceNum}-${checkNum}`;
      const detailState = updateDetailsAllData?.[detailKey];
      return detailObj?.isFormDirty || detailState?.flag === false;
    },
    [updateDetailsAllData]
  );

  const goToROSIPQAS = async (cellInfo) => {
    const currentCheckLogNum = viewCheckAllocationDetail.checkLogNum;
    const allocationInvoiceNum = cellInfo.invoiceNum;
    console.log(
      'currentCheckLogNum---',
      currentCheckLogNum,
      'allocationInvoiceNum',
      allocationInvoiceNum
    );

    console.log('activeScreenDetails', activeScreenDetails);
    const isSameInvDiffCheck = activeScreenDetails?.find(
      (item) =>
        item.invoiceNumber.toString() === allocationInvoiceNum.toString() &&
        item.checkNumber.toString() !== currentCheckLogNum.toString()
    );
    console.log(
      'isSameInvDiffCheck',
      isSameInvDiffCheck,
      'activeScreenDetails',
      activeScreenDetails
    );
    if (isSameInvDiffCheck) {
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${currentCheckLogNum})`
      );
      setAlreadyExistInvoiceNum(true);
      setWaringMessage(constantMessageData.ALREADY_EXIST_INVOICE_NUM_NAV);

      window.existingTabToClose = {
        checkNumber: isSameInvDiffCheck.checkNumber,
        invoiceNumber: isSameInvDiffCheck.invoiceNumber,
        tabId: `ROSI/PQAS [#${isSameInvDiffCheck.invoiceNumber}] Check Log #${isSameInvDiffCheck.checkNumber}`,
        navTo: `/allocatePaymentDetail/${isSameInvDiffCheck.checkNumber}-${isSameInvDiffCheck.invoiceNumber}`,
        hasUnsavedChanges: hasUnsavedChangesFor(
          isSameInvDiffCheck.invoiceNumber,
          isSameInvDiffCheck.checkNumber,
          updateDetailsAllData?.[
            `${isSameInvDiffCheck.invoiceNumber}-${isSameInvDiffCheck.checkNumber}`
          ]
        ),
        newTarget: {
          checkNumber: currentCheckLogNum,
          invoiceNumber: allocationInvoiceNum,
          mfgId: cellInfo.mfgId,
          planType: cellInfo.rebateProgramCd,
        },
      };
      return;
    }
    const newObj = [];
    newObj.push({
      index: newObj.length,
      invoiceNum: cellInfo.invoiceNum,
      checkLogNum: viewCheckAllocationDetail.checkLogNum,
      active: true,
    });
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: cellInfo.invoiceNum,
        checkLogNum: viewCheckAllocationDetail.checkLogNum,
        checkPayeeCD: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
        checkAmt:
          parseFloat(
            viewCheckAllocationDetail?.checkAmt?.toString().replace('$ ', '')
          ) || 0,
        mfgId: cellInfo.mfgId,
        planType: cellInfo.rebateProgramCd,
      })
    );
    dispatch(
      setPerviousScreenReduxData({
        ...searchScreenTabData,
        state: {
          ...searchScreenTabData.state,
          allocateFrom: 'Check',
        },
        selectedRow: {
          ...viewCheckAllocationDetail,
          checkPayeeCdVal: viewCheckAllocationDetail?.checkPayeeCd || 'MD',
        },
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      dispatch(dispatchActiveInvoiceNumber(newObj));
      const obj = { ...AllocatePaymentReducer?.detailScreenErrors };
      obj[
        `${headerAllocatePaymentVO?.invoiceNum}-${headerAllocatePaymentVO.checkLogNum}`
      ] = [];
      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: AllocatePaymentReducer?.searchScreenErrors
            ? AllocatePaymentReducer?.searchScreenErrors
            : [],
        })
      );
      dispatch(dispatchSaveDetailsResponse({}));
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj
      );
    } else if (data?.forzenCase) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
    } else if (data?.noCheckPayeeForInvoice) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle('Warning');
    }
  };
  // React.useEffect(() => {
  //   const handlePostSaveNavigation = () => {
  //     const tabs = JSON.parse(localStorage.getItem('tabItemsData')) || [];
  //     const currentPath = history.location.pathname;
  //     const currentTab = tabs.find((tab) => tab.navTo === currentPath);
  //     if (
  //       currentTab?.redirectURLObj?.destinationAfterSave &&
  //       !currentTab.isNavigating
  //     ) {
  //       const dest = currentTab.redirectURLObj.destinationAfterSave; // Update tab state to prevent recursion
  //       tabs.forEach((tab) => {
  //         if (tab.navTo === currentPath) {
  //           tab.isNavigating = true;
  //         }
  //       });
  //       localStorage.setItem('tabItemsData', JSON.stringify(tabs)); // Navigate to new combination
  //       if (dest.target) {
  //         redirectNewCombination(dest.target);
  //       }
  //     }
  //   };
  //   handlePostSaveNavigation();
  // }, [history.location.pathname]);
  return (
    <div
      className="tBillPanel custom-check tabs-container frr-view-check-allocation"
      data-testid="invoice-audit-detail"
    >
      <div className="align-item-center d-flex justify-content-between row">
        <CustomSeparator parent1="Tasks" parent2="Check Alloc Detail" />
        {!fullScreenView && !fullScreenView1 && (
          <div>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
            >
              <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
                <Dropdown.Toggle
                  className="icon-dropdown"
                  aria-label="Show Contracts using this Contact"
                >
                  <SVGComponent iconName="Icon-export" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    role="button"
                    data-testid="checkBtn"
                    onClick={handleMaintainCheck}
                  >
                    Go To Check
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </OverlayTrigger>
          </div>
        )}
      </div>
      <Spinner load={spinnerLoader} />
      {!fullScreenView && !fullScreenView1 && (
        <div className="tbl-checkbox">
          <div className="custom-check">
            <Box className="panel custom-fieldset frr-textfields">
              <div className="custom-check">
                <div className="form-wrapper form-wrapper-col-6">
                  <div className="mui-custom-form input-md mui-col-4">
                    <TextField
                      id="check_number"
                      label="Check Log Number"
                      data-testid="checkNumber"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxlength: 20 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={viewCheckAllocationDetail?.checkLogNum}
                    />
                  </div>
                  <div
                    className={
                      isNaN(
                        parseFloat(
                          removeDollarForNumberFiled(
                            removeCommaForNumberFiled(
                              viewCheckAllocationDetail?.checkAmt
                            )
                          )
                        )
                      )
                        ? 'mui-custom-form input-md mui-col-4'
                        : `mui-custom-form input-md mui-col-4 ${
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.checkAmt
                                )
                              )
                            ) >
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.checkAmt
                                )
                              )
                            )
                              ? 'frr-color-class-red'
                              : ''
                          } ${
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.checkAmt
                                )
                              )
                            ) >= 0
                              ? ''
                              : 'frr-color-red'
                          }`
                    }
                  >
                    <TextField
                      id="batch-total-amount-of-check-detail"
                      label="Check Amount"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={
                        isNaN(
                          parseFloat(
                            removeDollarForNumberFiled(
                              removeCommaForNumberFiled(
                                viewCheckAllocationDetail?.checkAmt
                              )
                            )
                          )
                        )
                          ? '$ 0.00'
                          : `${
                              parseFloat(
                                removeDollarForNumberFiled(
                                  removeCommaForNumberFiled(
                                    viewCheckAllocationDetail?.checkAmt
                                  )
                                )
                              ) >= 0
                                ? `$ ${parseFloat(
                                    removeDollarForNumberFiled(
                                      removeCommaForNumberFiled(
                                        viewCheckAllocationDetail?.checkAmt
                                      )
                                    )
                                  ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`
                                : `($ ${parseFloat(
                                    removeDollarForNumberFiled(
                                      removeCommaForNumberFiled(
                                        viewCheckAllocationDetail?.checkAmt
                                      )
                                    )
                                  )
                                    ?.toString()
                                    ?.replace('-', '')
                                    .trim()})`
                            }`
                      }
                    />
                  </div>
                  <div
                    className={
                      isNaN(
                        parseFloat(
                          removeDollarForNumberFiled(
                            removeCommaForNumberFiled(
                              viewCheckAllocationDetail?.totAllocatedAmt
                            )
                          )
                        )
                      )
                        ? 'mui-custom-form input-md mui-col-4'
                        : `mui-custom-form input-md mui-col-4 ${
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.totAllocatedAmt
                                )
                              )
                            ) >
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.totAllocatedAmt
                                )
                              )
                            )
                              ? 'frr-color-class-red'
                              : ''
                          } ${
                            parseFloat(
                              removeDollarForNumberFiled(
                                removeCommaForNumberFiled(
                                  viewCheckAllocationDetail?.totAllocatedAmt
                                )
                              )
                            ) >= 0
                              ? ''
                              : 'frr-color-red'
                          }`
                    }
                  >
                    <TextField
                      id="totAllocatedAmt"
                      label="Total Allocated Amount"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={
                        isNaN(
                          parseFloat(
                            removeDollarForNumberFiled(
                              removeCommaForNumberFiled(
                                viewCheckAllocationDetail?.totAllocatedAmt
                              )
                            )
                          )
                        )
                          ? '$ 0.00'
                          : `${
                              parseFloat(
                                removeDollarForNumberFiled(
                                  removeCommaForNumberFiled(
                                    viewCheckAllocationDetail?.totAllocatedAmt
                                  )
                                )
                              ) >= 0
                                ? `$ ${parseFloat(
                                    removeDollarForNumberFiled(
                                      removeCommaForNumberFiled(
                                        viewCheckAllocationDetail?.totAllocatedAmt
                                      )
                                    )
                                  ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`
                                : `($ ${parseFloat(
                                    removeDollarForNumberFiled(
                                      removeCommaForNumberFiled(
                                        viewCheckAllocationDetail?.totAllocatedAmt
                                      )
                                    )
                                  )
                                    ?.toString()
                                    ?.replace('-', '')
                                    .trim()})`
                            }`
                      }
                    />
                  </div>
                  <div className="mui-custom-form input-md mui-col-4">
                    <TextField
                      id="batchnum"
                      label="Batch Number"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={viewCheckAllocationDetail?.batchNum}
                    />
                  </div>
                  <div className="mui-custom-form input-md mui-col-4">
                    {viewCheckAllocationDetail?.checkIssuer &&
                    viewCheckAllocationDetail?.checkIssuer?.length > 30 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="com-tooltip">
                            {viewCheckAllocationDetail?.checkIssuer}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="CheckIssuer"
                          label="Check Issuer"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{ shrink: true }}
                          value={viewCheckAllocationDetail?.checkIssuer}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="CheckIssuer"
                        label="Check Issuer"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={viewCheckAllocationDetail?.checkIssuer}
                      />
                    )}
                  </div>
                  <div className="mui-custom-form input-md mui-col-4">
                    {viewCheckAllocationDetail?.checkInfo &&
                    viewCheckAllocationDetail?.checkInfo?.length > 30 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="com-tooltip">
                            {viewCheckAllocationDetail?.checkInfo}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="Information"
                          label="Information"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{ shrink: true }}
                          value={viewCheckAllocationDetail?.checkInfo}
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="Information"
                        label="Information"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={viewCheckAllocationDetail?.checkInfo}
                      />
                    )}
                  </div>
                  <div className="mui-custom-form input-md mui-col-4">
                    <TextField
                      id="DisputeResolution"
                      label="Dispute Resolution"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={viewCheckAllocationDetail?.disputeResolutionCd}
                    />
                  </div>
                  <div className="mui-custom-form input-md mui-col-4">
                    <TextField
                      id="ccd"
                      label="CCN"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={viewCheckAllocationDetail?.checkIdentifier}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="row">
                      <div className="col-md-6 pl-2 pr-0 pl-sm-1 pr-sm-1">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md field-xl">
                            <KeyboardDatePicker
                              data-test="start-date"
                              id="begindate-picker-dialog"
                              label="Check Date"
                              format="MM/dd/yyyy"
                              disabled
                              value={viewCheckAllocationDetail?.checkDt}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </div>
                      <div className="col-md-6 pr-2 pl-0 pl-sm-1 pr-sm-1">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md field-xl">
                            <KeyboardDatePicker
                              data-test="end-date"
                              id="endDate-picker-dialog"
                              label="Suspended Date"
                              format="MM/dd/yyyy"
                              disabled
                              inputProps={{ id: 'endDate-picker-dialog' }}
                              value={viewCheckAllocationDetail?.suspendedDt}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="row">
                      <div className="col-md-6 pr-2 pl-0 pl-sm-1 pr-sm-1">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md field-xl">
                            <KeyboardDatePicker
                              data-test="end-date"
                              id="postmarkDate"
                              label="Postmark Date"
                              format="MM/dd/yyyy"
                              disabled
                              inputProps={{ id: 'postmarkDate' }}
                              value={viewCheckAllocationDetail?.postmarkedDt}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </div>
                      <div className="col-md-6 pr-2 pl-0 pl-sm-1 pr-sm-1">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form with-select input-md field-xl">
                            <KeyboardDatePicker
                              data-test="end-date"
                              id="receivedDate"
                              label="Received Date"
                              format="MM/dd/yyyy"
                              disabled
                              inputProps={{ id: 'receivedDate' }}
                              value={viewCheckAllocationDetail?.receivedDt}
                              placeholder="mm/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                  </div>
                  {hasAccess && (
                    <div className="mui-custom-form input-md">
                      <div className="comment-sec mt-26">
                        Comments &nbsp;
                        <img
                          role="button"
                          onClick={() => {
                            setShowComments(true);
                          }}
                          tabIndex="0"
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setShowComments(true);
                            }
                          }}
                          alt="comment "
                          src={commentShow ? CommentVisibleIcon : CommentIcon}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </div>
        </div>
      )}
      {!fullScreenView1 && getInvoiceData && getInvoiceData?.length > 0 && (
        <div className="">
          <TableGridWithFeatures
            data-testid="View check Allocation"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : tableGridHight350}
            hideColumnsInPdf={['action']}
            rowData={getInvoiceData}
            columnDefs={TableHeaderForInvoiceNumber}
            exportFile
            animateRows
            sideBar={false}
            fileName="View check Allocation-Invoice"
            singleClickEdit
            isScrollOn
            navigateToNextCell={navigateToNextCell}
            // /tabToNextCell={tabToNextCell}
            gridCall={onGridReady}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            onSelect={(e) => {
              onRowSelect(e.data);
              setIndex(e.rowIndex);
              dispatch(
                setViewCheckAllocationTab({
                  ...viewCheckAllocationTab,
                  index: e.rowIndex,
                })
              );
            }}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                return (
                  <div
                    className="tdCell icon-btn-group"
                    data-testid="action-column"
                  >
                    <Dropdown className="icon-dropdown-container">
                      <Dropdown.Toggle
                        className="icon-dropdown export_wrap"
                        aria-label="export"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="action-tooltip">Actions</Tooltip>
                          }
                        >
                          <SVGComponent iconName="Icon-export" />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export_dropdown">
                        <Dropdown.Item
                          role="button"
                          onClick={() =>
                            handleViewDetailsForInvoiceDetail(cellInfo?.data)
                          }
                        >
                          Go To Invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => goToROSIPQAS(cellInfo?.data)}
                        >
                          Go To ROSI/PQAS
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              nameRenderMFG: (cellInfo) => {
                const name = cellInfo.data && cellInfo.data.mfgName;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      )}
      {!fullScreenView && (
        <div className="">
          <TableGridWithFeatures
            data-testid="View check Allocation"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView1}
            handleFullScreenViewClick={handleFullScreenView1}
            gridHeight={fullScreenView1 ? '70vh' : tableGridHight350}
            rowData={quarterGridList}
            columnDefs={TableHeaderForQuarter}
            hideColumnsInPdf={['action']}
            exportFile
            animateRows
            noGlobalSort
            sideBar={false}
            fileName="View check Allocation-Quarter"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                return (
                  <div
                    className="tdCell icon-btn-group"
                    data-testid="action-column"
                  >
                    <Dropdown className="icon-dropdown-container">
                      <Dropdown.Toggle
                        className="icon-dropdown export_wrap"
                        aria-label="export"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="action-tooltip">Actions</Tooltip>
                          }
                        >
                          <SVGComponent iconName="Icon-export" />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export_dropdown">
                        <Dropdown.Item
                          role="button"
                          onClick={() =>
                            handleViewDetailsForInvoiceDetail(cellInfo?.data)
                          }
                        >
                          Go To Invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => goToROSIPQAS(cellInfo?.data)}
                        >
                          Go To ROSI/PQAS
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              intrestPaidAmtRender: (cellInfo) => {
                return (
                  <>
                    {cellInfo?.data?.negativeValIntrestPaidAmt ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.intrestPaidAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{cellInfo?.data?.intrestPaidAmt}</div>
                    )}
                  </>
                );
              },
              principalPaidAmtRender: (cellInfo) => {
                return (
                  <>
                    {cellInfo?.data?.negativeValPrincipalPaidAmt ? (
                      <div
                        style={{ color: RedColor }}
                      >{`(${cellInfo?.data?.principalPaidAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{cellInfo?.data?.principalPaidAmt}</div>
                    )}
                  </>
                );
              },
            }}
          />
        </div>
      )}
      <CommonModal
        className="dialog-420"
        data-testid="commonModal1"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => setWarningAlert(false)}
        onClose={() => setWarningAlert(false)}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      />
      <CommonModal
        className='dialog-420'
        data-testid='sameInvDiffCheckModal'
        open={alreadyExistInvoiceNum}
        viewAction
        viewHeader
        onOk={handleReplaceModalOk}
        onClose={() => {
          setAlreadyExistInvoiceNum(false);
          if (window.existingTabToClose) {
            window.existingTabToClose = null;
          }
        }}
        okTitle='Ok'
        closeTitle='No'
        modalTitle={modalTitle}
        childrenComponent={<div className='p-3'>{warningMessage}</div>}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CHECK_LOG"
          corrLinkId={viewCheckAllocationDetail?.corrLinkId}
          rowGridPrimaryKey={viewCheckAllocationDetail?.checkLogNum.toString()}
        />
      ) : null}
    </div>
  );
}

export default ViewCheckAllocation;
